/**
 *
 * InfoPage
 *
 */

import Container from '@material-ui/core/Container';
import PropTypes from 'prop-types';
import React, { useContext, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import dfn01 from '../../images/info/definix-token.png';
import dfn04 from '../../images/info/finix-challenge.png';
import dfn03 from '../../images/info/governance-token.png';
import dfn02 from '../../images/info/investment-privilege.png';
import { Context } from '../../store/lang';
import '../../stylesheets/info.scss';
import messages from './messages';

function InfoPage({ intl }) {
  const context = useContext(Context);
  const { lang } = useParams();

  useEffect(() => {
    context.lang.set(lang);
  }, [context.lang, lang]);

  const dataS2 = [
    {
      img: dfn02,
      title: intl.formatMessage({ ...messages.s2.investment }),
      detail: intl.formatMessage({ ...messages.s2.investment2 }),
    },
    {
      img: dfn03,
      title: intl.formatMessage({ ...messages.s2.governance }),
      detail: intl.formatMessage({ ...messages.s2.governance2 }),
    },
    {
      img: dfn04,
      title: intl.formatMessage({ ...messages.s2.finix }),
      detail: intl.formatMessage({ ...messages.s2.finix2 }),
    },
  ];

  return (
    <div className="info-page">
      <section>
        <Container className="flex flex-column align-center">
          <h1 className="text-center">
            {intl.formatMessage({ ...messages.s1.title })}
          </h1>
          <img src={dfn01} alt="" />
          <p>{intl.formatMessage({ ...messages.s1.detail })}</p>
        </Container>
      </section>

      <section className="bg-gray">
        <Container>
          {dataS2.map((d, idx) => (
            <div
              className="rotate-content to-h align-center large py-6"
              key={`s3${idx}`}
            >
              <img src={d.img} alt="" />
              <div className="content">
                <h3 className="mb-3">{d.title}</h3>
                <p className="ma-0">{d.detail}</p>
              </div>
            </div>
          ))}
        </Container>
      </section>
    </div>
  );
}

InfoPage.propTypes = { intl: PropTypes.object };

export default injectIntl(InfoPage);
